import { render, staticRenderFns } from "./AddEmail.vue?vue&type=template&id=32727afc"
import script from "./AddEmail.vue?vue&type=script&lang=js"
export * from "./AddEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports